$(document).ready(function() {
    var collapsibleContentComponent = $(
        "body:not(.website-state-edit) .module-text-accordion-content"
    );

    if (collapsibleContentComponent.length > 0) {
        collapsibleContentComponent.hide();

        //WRAP CONTENT BETWEEN H2 HEADINGS IN DIVS
        $(".module-text-accordion-content h2").each(function() {
            $(this)
                .attr("tabindex", "0")
                .addClass("closed")
                .nextUntil("h2")
                .wrapAll(
                    '<div style="display: none;" class="module-text-accordion-content-section" />'
                );
        });

        //ADD CLICK EVENT TO SHOW/HIDE CONTENT BELOW HEADERS
        $(".module-text-accordion-content h2").on("click", function(event) {
            event.preventDefault();
            $(this)
                .toggleClass("closed")
                .next()
                .slideToggle("fast")
                .trigger("accordionToggled");
        });

        //HANDLE KEYPRESS ON COLLAPSIBLE HEADERS AND TOGGLE-ALL
        $(".module-text-accordion-content h2").keypress(function(event) {
            if (event.which == 13 || event.which == 32) {
                event.preventDefault();
                this.click();
            }
        });

        //SHOW AFTER TRANSFORMATION
        collapsibleContentComponent.show();
    }
});
